import React from 'react';
import PropTypes from 'prop-types';
import Currency from '../_utils/tools/currency';

const CrossSellPanel = ({ item }) => {
  if (!item) return null;

  const { name, price, url, thumbnail, type } = item;

  const text =
    type === 'PrismCategory'
      ? `Browse our collection of ${name}`
      : price != null
        ? `Add a ${name} from only ${Currency.format(price)}`
        : `Add a ${name}`;

  return (
    <div className="cross-sell mt-3">
      <div className="p-3">
        <div className="d-flex align-items-center mb-2">
          {thumbnail && (
            <div className="cross-sell__thumb mr-3">
              <img src={thumbnail} alt={`Thumbnail of ${name}`} />
            </div>
          )}
          <div>
            <span className="font-weight-bold">
              Other customers considered:
            </span>
            <p className="mb-0">{text}</p>
          </div>
        </div>
        <div className="d-flex justify-content-end">
          <a
            href={url}
            className="btn btn-primary rounded-pill mt-2 cross-sell__btn">
            Shop now
          </a>
        </div>
      </div>
    </div>
  );
};

CrossSellPanel.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string.isRequired,
    price: PropTypes.number,
    url: PropTypes.string.isRequired,
    thumbnail: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }),
};

export { CrossSellPanel };
